<template>
  <div class="login-page">
    <div class="login-card anim-fade-in-scale">
      <img src="../assets/xiaohui.png" alt="校徽" class="login-logo" />
      <h1 class="login-title">SDU—HFLIBS</h1>
      <p class="login-subtitle">可视化分析系统</p>
      <hr class="rule-accent" />
      <p class="login-desc">山东大学 · 行星科学团队</p>

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="login-form">
        <el-form-item prop="role">
          <div class="role-select-wrap">
            <i class="el-icon-s-home role-prefix-icon"></i>
            <el-select v-model="ruleForm.role" placeholder="请选择登录角色" class="role-select">
              <el-option label="用户" value="用户" />
              <el-option label="管理员" value="管理员" />
            </el-select>
          </div>
        </el-form-item>

        <el-form-item prop="account">
          <el-input
            v-model="ruleForm.account"
            placeholder="请输入账号"
            prefix-icon="el-icon-user"
            maxlength="6"
            show-word-limit
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="ruleForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            @keyup.enter.native="submitForm"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loggingIn" class="login-btn">
            登 录
          </el-button>
        </el-form-item>
      </el-form>

      <div class="login-footer">
        <span>还没有账号？</span>
        <a @click.prevent="toTegister" class="reg-link">立即注册</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px 20px;
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-elevated);
  padding: 44px 36px 36px;
  text-align: center;
}

.login-logo {
  width: 56px; height: 56px;
  border-radius: 50%;
  margin-bottom: 14px;
}

.login-title {
  font-family: var(--font-display);
  font-size: 2rem; font-weight: 500;
  color: var(--text-primary);
  margin: 0 0 2px;
  letter-spacing: 0.05em;
}

.login-subtitle {
  font-family: var(--font-body);
  font-size: 0.9rem; font-weight: 400;
  color: var(--text-muted);
  margin: 0 0 16px;
  letter-spacing: 0.12em;
}

.rule-accent {
  width: 48px; height: 2px;
  background: var(--accent-primary);
  border: none;
  margin: 0 auto 14px;
}

.login-desc {
  font-size: 0.82rem;
  color: var(--text-muted);
  margin: 0 0 28px;
}

.login-form {
  text-align: left;
  margin-top: 4px;
}

.login-btn {
  width: 100%; height: 44px;
  font-size: 0.95rem;
  letter-spacing: 0.25em;
  border-radius: var(--radius-sm);
  margin-top: 4px;
}

.role-select-wrap { position: relative; width: 100%; }
.role-prefix-icon {
  position: absolute; left: 10px; top: 50%; transform: translateY(-50%);
  z-index: 10; color: var(--text-muted); font-size: 0.9rem;
}
.role-select { width: 100%; }

::v-deep .role-select-wrap .el-input__inner {
  height: 40px;
  padding-left: 30px;
}

.login-footer {
  text-align: center;
  font-size: 0.82rem;
  color: var(--text-muted);
  margin-top: 20px;
}

.reg-link {
  color: var(--accent-primary);
  cursor: pointer;
  margin-left: 4px;
  transition: color var(--transition-fast);
}
.reg-link:hover {
  color: #9A6F0A;
  text-decoration: underline;
}

@media screen and (max-width: 480px) {
  .login-card { padding: 32px 20px 28px; }
  .login-title { font-size: 1.6rem; }
}
</style>

<script>
export default {
  data() {
    return {
      loggingIn: false,
      ruleForm: { account: '', password: '', role: '用户' },
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '账号长度为6位数字', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      }
    }
  },

  methods: {
    toTegister() { this.$router.push('/zhuce'); },

    submitForm() {
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return;
        this.loggingIn = true;
        try {
          const url = this.ruleForm.role === '管理员' ? '/adm/login' : '/user/login';
          const payload = { account: this.ruleForm.account, password: this.ruleForm.password };
          const resp = await this.$axios.post(url, payload);
          if (resp.data.code === 0) {
            this.$message.success('登录成功');
            const target = this.ruleForm.role === '管理员' ? '/admin/home' : '/user/home';
            this.$router.push(target);
          } else {
            this.$message.error(resp.data.msg || '登录失败');
          }
        } catch (e) {
          this.$message.error('登录请求失败，请检查网络连接');
        } finally {
          this.loggingIn = false;
        }
      });
    }
  }
}
</script>
